import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ARMFloorTooltipContent({firstName}) {
  const { t } = useTranslation(["arm_floor"]);
  return t("arm_floor_tooltip_content", {name: firstName})
}